import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable, ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {AbmsBoardService} from '../../../../../domain/model/licenses-certifications/board/abms/abms-board.service';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {AbmsBoard} from '../../../../../domain/model/licenses-certifications/board/abms/abms-board.model';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocation, FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {AbmsBoardScreensManager} from './abms-board-screens-manager.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import {VerificationService} from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./abms-board-screen.component.html')
})
export class AbmsBoardScreenComponent {

    constructor(readonly modelService: AbmsBoardService,
                readonly route: ActivatedRoute,
                readonly screensManager: AbmsBoardScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    certifications: Array<string> = [
        'American Board of Allergy and Immunology',
        'American Board of Anesthesiology',
        'American Board of Colon and Rectal Surgery',
        'American Board of Dermatology',
        'American Board of Disaster Medicine',
        'American Board of Emergency Medicine',
        'American Board of Family Medicine',
        'American Board of Hospital Medicine',
        'American Board of Integrative Medicine',
        'American Board of Internal Medicine',
        'American Board of Medical Genetics and Genomics',
        'American Board of Medical Specialties',
        'American Board of Neurological Surgery',
        'American Board of Nuclear Medicine',
        'American Board of Obstetrics and Gynecology',
        'American Board of Ophthalmology',
        'American Board of Orthopaedic Surgery',
        'American Board of Otolaryngology',
        'American Board of Pathology',
        'American Board of Pediatrics',
        'American Board of Physical Medicine and Rehabilitation',
        'American Board of Plastic Surgery',
        'American Board of Preventive Medicine',
        'American Board of Psychiatry and Neurology',
        'American Board of Radiology',
        'American Board of Surgery',
        'American Board of Thoracic Surgery',
        'American Board of Urology'
    ];

    certificationDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    supportingDocumentFileLocation: FileLocation;

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<AbmsBoard>({
        initialDataModel: new AbmsBoard(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.supportingDocumentFileLocation = this.fileLocationFactory.create('abmsBoard', `currentUser/${this.index}`, new ProjectionInformation('supportingDocument'));
            this.verificationService.setUrl('abmsBoard', undefined, `${this.index}`);
            return this.modelService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: AbmsBoard) => {
            return this.modelService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.index !== 1 ? this.modelService.doesCurrentUserModelEntryExist(this.index).map(r => !r) : Observable.of(false)
    });

    get model(): AbmsBoard {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleCurrentlyCertifiedChange() {
        if (!this.model.currentlyCertified) this.model.certificationDate = undefined;
    }

    handleRecertifiedChange() {
        if (!this.model.recertified) this.model.recertificationDate = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/abms/abms-board-screen.component.ts